let cachedAudio;
let unlocked = false;
function getAudio() {
    if (!cachedAudio) {
        cachedAudio = new Audio('/sounds/request-notification.wav');
        cachedAudio.volume = 0.5;
    }
    return cachedAudio;
}
/**
 * iOS Safari blocks programmatic audio playback unless the HTMLAudioElement
 * has been played at least once inside a user-gesture event handler.
 * We play it silently on the first tap/click to satisfy that policy.
 */
function unlockAudioForIOS() {
    if (unlocked)
        return;
    const audio = getAudio();
    const originalVolume = audio.volume;
    audio.volume = 0;
    audio
        .play()
        .then(() => {
        audio.pause();
        audio.currentTime = 0;
        audio.volume = originalVolume;
        unlocked = true;
    })
        .catch(() => undefined);
}
if (typeof document !== 'undefined') {
    const handler = () => {
        unlockAudioForIOS();
        document.removeEventListener('touchstart', handler, true);
        document.removeEventListener('click', handler, true);
    };
    document.addEventListener('touchstart', handler, true);
    document.addEventListener('click', handler, true);
}
export function playRequestNotificationSound() {
    try {
        const audio = getAudio();
        audio.currentTime = 0;
        audio.play().catch(() => undefined);
    }
    catch {
        // Audio may be unavailable
    }
}
